<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Header Section -->
      <div class="card">
        <div class="card-header">
          <h4 class="card-header-title">Training Category</h4>
          <!-- <b-button variant="primary" @click="addTrainingCategory" v-if="listTabMenu?.privilages?.create"> -->
          <b-button variant="primary" @click="addTrainingCategory">
            <span class="fe fe-file-plus"></span>
            Add Training Category
          </b-button>
        </div>

        <!-- Filter Section -->
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <v-select
                v-model="filters.role_competency_id"
                :options="roleCompetencyOptions"
                label="role_competency_name"
                :reduce="option => option.id"
                placeholder="Select Role Competency"
                @input="onFilterChange">
              </v-select>
            </div>
            <div class="col-md-4">
              <b-form-input
                v-model="filters.search"
                placeholder="Search by abbreviation or title..."
                @input="onSearch">
              </b-form-input>
            </div>
            <div class="col-md-2">
              <b-button variant="outline-primary" @click="clearFilter">
                <span class="fe fe-x-square"></span>
                Clear Filter
              </b-button>
            </div>
          </div>
        </div>

        <!-- Data Table -->
        <div class="card-body">
          <vue-good-table
            :line-numbers="true"
            :columns="columns"
            :total-rows="totalItems"
            :rows="trainingCategories"
            :sort-options="{
              enabled: true
            }"
            :pagination-options="{
              enabled: true,
              mode: 'pages',
              position: 'bottom',
              perPage: body.limit,
              perPageDropdown: [10, 25, 50, 100],
              dropdownAllowAll: false,
              setCurrentPage: body.page,
              nextLabel: 'Next',
              prevLabel: 'Prev',
              rowsPerPageLabel: 'Rows per page',
              ofLabel: 'of',
              pageLabel: 'page',
              allLabel: 'All'
            }"
            styleClass="vgt-table border-0 table"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            @on-sort-change="onSortChange">

            <!-- Empty State -->
            <div slot="emptystate" class="text-center font-size-14 py-4">
              No data available
            </div>

            <!-- Custom Column Templates -->
            <template slot="table-row" slot-scope="props">
              <!-- Role Comptency ID -->
              <span v-if="props.column.field === 'abbreviation'">
                {{ props.row.abbreviation }}
              </span>

              <!-- Role Comptency ID -->
              <span v-if="props.column.field === 'title'">
                {{ props.row.title }}
              </span>

              <!-- Role Comptency ID -->
              <span v-if="props.column.field === 'role_competency_name'">
                {{ props.row.role_competency.role_competency_name }}
              </span>

              <!-- Actions -->
              <span v-if="props.column.field === 'actions'" class="d-flex justify-content-center">
                <b-button
                  variant="warning"
                  size="sm"
                  class="mr-1"
                  @click="editTrainingCategory(props.row)"
                  title="Edit">
                  <span class="fe fe-edit"></span>
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  @click="deleteTrainingCategory(props.row)"
                  title="Delete">
                  <span class="fe fe-trash"></span>
                </b-button>
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>

      <!-- Add/Edit Modal -->
      <b-modal
        v-model="showModal"
        :title="modalTitle"
        size="lg"
        hide-footer
        @hide="resetForm">
        
        <form @submit.prevent="saveTrainingCategory">
          <div class="row">
            <!-- Abbreviation -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Abbreviation <span class="text-danger">*</span></label>
                <b-form-input
                  v-if="isAdd"
                  v-model="bodyAdd.abbreviation"
                  placeholder="Enter abbreviation"
                  :class="{ 'is-invalid': formErrors.abbreviation }"
                  maxlength="10">
                </b-form-input>
                <b-form-input
                  v-else
                  v-model="bodyUpdate.abbreviation"
                  placeholder="Enter abbreviation"
                  :class="{ 'is-invalid': formErrors.abbreviation }"
                  maxlength="10">
                </b-form-input>
                <div v-if="formErrors.abbreviation" class="invalid-feedback">
                  {{ formErrors.abbreviation }}
                </div>
              </div>
            </div>

            <!-- Role Competency -->
            <div class="col-md-6">
              <div class="form-group">
                <label>Role Competency <span class="text-danger">*</span></label>
                <v-select
                  v-if="isAdd"
                  v-model="bodyAdd.role_competency_id"
                  :options="roleCompetencyOptions"
                  label="role_competency_name"
                  :reduce="option => option.id"
                  placeholder="Select Role Competency"
                  :class="{ 'is-invalid': formErrors.role_competency_id }">
                </v-select>
                <v-select
                  v-else
                  v-model="bodyUpdate.role_competency_id"
                  :options="roleCompetencyOptions"
                  label="role_competency_name"
                  :reduce="option => option.id"
                  placeholder="Select Role Competency"
                  :class="{ 'is-invalid': formErrors.role_competency_id }">
                </v-select>
                <div v-if="formErrors.role_competency_id" class="invalid-feedback">
                  {{ formErrors.role_competency_id }}
                </div>
              </div>
            </div>

            <!-- Title -->
            <div class="col-md-12">
              <div class="form-group">
                <label>Title <span class="text-danger">*</span></label>
                <b-form-input
                  v-if="isAdd"
                  v-model="bodyAdd.title"
                  placeholder="Enter title"
                  :class="{ 'is-invalid': formErrors.title }">
                </b-form-input>
                <b-form-input
                  v-else
                  v-model="bodyUpdate.title"
                  placeholder="Enter title"
                  :class="{ 'is-invalid': formErrors.title }">
                </b-form-input>
                <div v-if="formErrors.title" class="invalid-feedback">
                  {{ formErrors.title }}
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="d-flex justify-content-end mt-3">
            <b-button variant="secondary" class="mr-2" @click="showModal = false">
              Cancel
            </b-button>
            <b-button 
              variant="primary" 
              type="submit"
              :disabled="isSubmitting">
              <span v-if="isSubmitting" class="spinner-border spinner-border-sm mr-1"></span>
              {{ isAdd ? 'Create' : 'Update' }}
            </b-button>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
</template>
<script>
  import { props } from 'vue2-dropzone';
import logic from './training-category.logic.js';
  
  export default {
    ...logic,
  };
</script>

<style scoped src="./training-category.css"></style>
